import { useContext } from 'react';
import impersonationContext from './impersonationContext';

const useImpersonation = () => useContext(impersonationContext);

export default useImpersonation;
